import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { ListActiveAndCompletedInvoiceContext } from 'src/context';
import DesktopListInvoices from 'src/components/DesktopListInvoices';
import NoData from 'src/components/NoData';
import { PAY_REQUEST } from 'src/screens/routes';
import PayTable from './components/PayTable';

const DesktopPay = () => {
  const { t } = useTranslation('invoice');
  return (
    <DesktopListInvoices>
      <div className="title-container">
        <h1>{t('pay')}</h1>
        <Link to={PAY_REQUEST}>
          <Button className="invert-primary-dark-button">
            {t('newInvoice')}
          </Button>
        </Link>
      </div>
      <div className="invoice-table-container drop-shadow">
        <ListActiveAndCompletedInvoiceContext.Consumer>
          {(invoices: any) => {
            return (
              <>
                <PayTable invoices={invoices} />
                {!invoices.length && <NoData />}
              </>
            )
          }}
        </ListActiveAndCompletedInvoiceContext.Consumer>
      </div>
    </DesktopListInvoices>
  )
}

export default DesktopPay;